<template>
<div>
        <!-- <div id="preloader">
            <div id="status">
                <div class="logo">
                    <img src="../assets/images/logo-dark.png" height="25" class="d-block mx-auto" alt="">
                </div>
                <div class="sk-chase mt-4">
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                    <div class="sk-chase-dot"></div>
                </div>
            </div>
        </div> -->
        <!-- Loader End -->

        <!-- Navbar STart -->
        <header id="topnav" class="defaultscroll sticky">
            <div class="container">
                <!-- Logo container-->
                <div>
                  <router-link to="/">
                    <img src="https://video.ipeakexam.com/website/logoxing.png" class="logo" style="width: 190px;height: 60px;margin-top:10px ">
                  </router-link>
                    <!--                    <router-link class="logo" to="/" style="color:#FFF">爱拼考</router-link>-->
                </div>
                <div class="buy-button">
                    <a href="https://pc.ipeakexam.com" >

                        <div class="btn btn-success login-btn-light">用户端登录</div>
                    </a>
                  &nbsp;&nbsp;
                  <a href="https://exam.ipeakexam.com" target="_blank">

                        <div class="btn btn-light login-btn-light">平台端登录</div>
                    </a>
                </div><!--end login button-->
                <!-- End Logo container-->
                <div class="menu-extras">
                    <div class="menu-item">
                        <!-- Mobile menu toggle-->
                        <a class="navbar-toggle" @click="toggleClick">
                            <div class="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </a>
                        <!-- End mobile menu toggle-->
                    </div>
                </div>

                <div id="navigation">
                    <!-- Navigation Menu-->
                    <ul class="navigation-menu" :class="pathClass">
                         <li><router-link to="/">首页</router-link></li>
                        <li class="has-submenu">
                            <a href="javascript:void(0)">产品</a><span class="menu-arrow" ></span>
                            <ul class="submenu">
                                <li><router-link to="/lesson">在线课程学习</router-link></li>
                                 <li><router-link to="/drillExam">在线练习考试</router-link></li>
                                <li><router-link to="/participation">线上互动参与</router-link></li>
<!--                                <li><router-link to="/wechat">移动应用</router-link></li>-->
                                <!-- <li><router-link to="/questions">问卷调查</router-link></li> -->
<!--                                <li><router-link to="/earnings">内容变现计划<span class="badge badge-pill badge-danger">新</span></router-link></li>-->
                            </ul>
                        </li>

<!--                        <li class="has-submenu">-->
<!--                            <a href="javascript:void(0)">解决方案</a><span class="menu-arrow"></span>-->
<!--                            <ul class="submenu">-->
<!--                                <li><router-link to="/solution/edu">教育机构</router-link></li>-->
<!--                                <li><router-link to="/solution/enterprise">企业培训</router-link></li>-->
<!--                                <li><router-link to="/solution/medical">医疗机构</router-link></li>-->
<!--                                <li><router-link to="/solution/financial">金融行业</router-link></li>-->
<!--&lt;!&ndash;                                <li><router-link to="/feature_product">生产企业</router-link></li>&ndash;&gt;-->
<!--&lt;!&ndash;                                <li><router-link to="/feature">社区服务</router-link></li>&ndash;&gt;-->
<!--&lt;!&ndash;                                <li><router-link to="/feature">党建服务</router-link></li>&ndash;&gt;-->
<!--                            </ul>-->
<!--                        </li>-->

                        <!-- <li class="has-submenu">
                            <a href="javascript:void(0)">新闻资讯</a><span class="menu-arrow"></span>
                            <ul class="submenu">
                                <li><router-link to='/news'>公司动态</router-link></li>
                                <li><router-link to='/news'>行业资讯</router-link></li>
                            </ul>
                        </li> -->
                        <li class="has-submenu">
                            <a href="javascript:void(0)">关于</a><span class="menu-arrow"></span>
                            <ul class="submenu">
                                <li><router-link to="/us">公司简介</router-link></li>
<!--                                <li><router-link to="/team">核心团队</router-link></li>-->
                                <!-- <li><router-link to="/us">研发合作</router-link></li>
                                <li><router-link to="/us">社会责任</router-link></li> -->
                                <li><router-link to="/timeline">发展历程</router-link></li>
                                <li><router-link to="/certificate">资质证书</router-link></li>
                                <li><router-link to="/responsibility">企业社会责任</router-link></li>
<!--                              <li ><a href="https://exam-ipeakexam.oss-cn-shanghai.aliyuncs.com/website/%E7%88%B1%E6%8B%BC%E8%80%83%E4%BA%A7%E5%93%81%E5%AE%A3%E4%BC%A0%E6%89%8B%E5%86%8C%EF%BC%882021%E5%B9%B47%E6%9C%88%E7%89%88%EF%BC%89.pdf"  >产品宣传手册</a></li>-->
                                <li><router-link to="/privacy">隐私条例&法律声明</router-link></li>
                            </ul>
                        </li>

                        <li><router-link to="/contact">联系我们</router-link></li>
                    </ul><!--end navigation menu-->
                </div><!--end navigation-->
            </div><!--end container-->
        </header><!--end header-->
        <!-- Navbar End -->
</div>
</template>
<script>

    // Menu
    $('.navbar-toggle').on('click', function (event) {
        $(this).toggleClass('open');
        $('#navigation').slideToggle(400);
    });

    $('.navigation-menu>li').slice(-1).addClass('last-elements');

    $('.menu-arrow,.submenu-arrow').on('click', function (e) {
        if ($(window).width() < 992) {
            e.preventDefault();
            $(this).parent('li').toggleClass('open').find('.submenu:first').toggleClass('open');
        }
    });

    $(".navigation-menu a").each(function () {
        if (this.href == window.location.href) {
            $(this).parent().addClass("active");
            $(this).parent().parent().parent().addClass("active");
            $(this).parent().parent().parent().parent().parent().addClass("active");
        }
    });

export default {
    data () {
            return {
                pathClass:"nav-dark"
            }
        },
    mounted () {

        },
        beforeDestroy () {

        },
        methods: {
            toggleClick() {
                  $(this).toggleClass('open');
                  $('#navigation').slideToggle(400);
                  $('.navigation-menu>li').slice(-1).addClass('last-elements');
                  if ($(window).width() < 992) {
                    $('.navigation-menu>li').toggleClass('open').find('.submenu:first').toggleClass('open');
                 }
            },
        },
    watch: {
        $route(to, from) {
         let path = this.$route.path
         if(path != '/'){
             this.pathClass=""
         }else if(path =='wechat'){
              this.pathClass="nav-light"
         }
         else{
             this.pathClass="nav-light"
         }

    }
},

}
</script>


